import { useEffect, useState } from 'react'

/** Returns state that is true when a user's mouse button is down. */
function useMouseEvents(): MouseEvent | null {
  const [mouseDownEvent, setMouseDownEvent] = useState<MouseEvent | null>(null)
  useEffect(() => {
    const mouseDownHandler = (e: MouseEvent) => {
      setMouseDownEvent(e)
    }

    const mouseUpHandler = () => {
      setMouseDownEvent(null)
    }

    window.addEventListener('mousedown', mouseDownHandler, true)
    window.addEventListener('mouseup', mouseUpHandler, true)

    return () => {
      window.removeEventListener('mousedown', mouseDownHandler, true)
      window.removeEventListener('mouseup', mouseUpHandler, true)
    }
  }, [])

  return mouseDownEvent
}

export { useMouseEvents }
